module.exports = __webpack_public_path__ + "static/media/yunda-express.2e1f27a6.svg";